import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useIntl } from 'react-intl';
import {
  selectQuestionnaireResponse,
  selectResults,
  selectResultsSelectedDate,
} from '../../redux/reducers/results';
import { useSelector } from 'react-redux';
import { ResultsCard } from './ResultsCard';
import { ResultCategories } from './Results';
import { calculateResultAlgorithmForCategory } from './ResultsAlgorithmUtility';
import { NotesCard } from './NotesCard';

export const ResultsCardsSection = ({ isMobile }) => {
  const intl = useIntl();
  const results = useSelector(selectResults);
  const selectedDate = useSelector(selectResultsSelectedDate);
  const questionnaireResponse = useSelector(selectQuestionnaireResponse);
  const [algorithmResults, setAlgorithmResults] = useState({});

  useEffect(() => {
    // Find the index of the selected date.
    const indexOfSelectedResult = results.map((result) => result.date).indexOf(selectedDate);
    if (indexOfSelectedResult !== -1) {
      const selectedResult = results[indexOfSelectedResult];
      const resultsForAllCategories = Object.values(ResultCategories).reduce(
        (accumulator, category) => {
          return category in selectedResult
            ? {
                ...accumulator,
                [category]: calculateResultAlgorithmForCategory(
                  intl,
                  category,
                  selectedResult[category],
                ),
              }
            : accumulator;
        },
        {},
      );

      setAlgorithmResults(resultsForAllCategories);
    } else {
      setAlgorithmResults({});
    }
  }, [results, selectedDate, intl, questionnaireResponse]);

  const getAlgorithmResultsFor = (category) => {
    return algorithmResults ? algorithmResults[category] : undefined;
  };

  return (
    <Box
      mr={isMobile ? '-0.75rem' : '0rem'}
      sx={{
        display: 'flex',
        overflowX: 'auto',
        scrollbarWidth: 'none' /* Firefox */,
        '&::-webkit-scrollbar': {
          display: 'none' /* Chrome, Safari, and Opera */,
        },
      }}
    >
      <Grid
        container
        direction="row"
        spacing={{ xs: 1.5, sm: 4, lg: 8 }}
        wrap={isMobile ? 'nowrap' : 'wrap'}
        justifyContent={'flex-start'}
      >
        {Object.values(ResultCategories).map((category, index) => {
          const algorithmResult = getAlgorithmResultsFor(category);
          // If there is an algorithm result for the category, then make the card.
          return !!algorithmResult ? (
            <Grid item sm={6} md={4} key={'results-card-' + index}>
              {(algorithmResult.isNotesCard && (
                <NotesCard
                  title={algorithmResult.title}
                  background={algorithmResult.color}
                  placeholder={algorithmResult.message}
                  questionnaireResponse={questionnaireResponse[0]?.resource}
                />
              )) || (
                <ResultsCard
                  title={algorithmResult.title}
                  background={algorithmResult.color}
                  score={algorithmResult.score}
                  icon={algorithmResult.icon}
                  description={algorithmResult.message}
                />
              )}
            </Grid>
          ) : (
            <Grid item xs={4} key={'results-card-' + index} />
          );
        })}
      </Grid>
    </Box>
  );
};
